// Contacto: with ?producto=<handle>, look the product up through the AJAX API, prefill the message
// with its name and select "Producto del catálogo". An unknown handle leaves the form untouched;
// a message the visitor already typed (or the server re-rendered after an error) is never replaced.
(function () {
  'use strict';

  var handle = new URLSearchParams(window.location.search).get('producto');
  var body = document.querySelector('[data-contact-body]');
  var service = document.querySelector('[data-contact-service]');
  if (!handle || !body || body.value.trim() !== '') return;

  fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
    .then(function (r) {
      if (!r.ok) throw new Error('product not found');
      return r.json();
    })
    .then(function (product) {
      if (body.value.trim() !== '') return;
      body.value = body.dataset.prefill.replace('__NAME__', product.title);
      if (service && service.options.length) {
        service.selectedIndex = service.options.length - 1;
      }
    })
    .catch(function () {});
})();
